import { post, get, tokenUtils } from './api'

const AUTH_PREFIX = '/blade-portal/auth'

export const authService = {
  /**
   * 用户登录
   */
  async login(account, password) {
    const response = await post(`${AUTH_PREFIX}/login`, { account, password })
    // Save tokens
    if (response.accessToken) {
      tokenUtils.setToken(response.accessToken)
      if (response.refreshToken) {
        tokenUtils.setRefreshToken(response.refreshToken)
      }
    }
    return response
  },

  /**
   * 用户注册
   */
  async signup(data) {
    const response = await post(`${AUTH_PREFIX}/signup`, {
      fullName: data.fullName,
      phone: data.phone,
      email: data.email,
      password: data.password,
      companyName: data.companyName,
      // 渠道归因：提交的是【令牌】，推荐码由后端自行解析（客户端传的码不被采信）
      referralToken: data.referralToken,
      referralCode: data.referralCode,
      landingUrl: data.landingUrl,
    })
    // Auto login after signup
    if (response.accessToken) {
      tokenUtils.setToken(response.accessToken)
      if (response.refreshToken) {
        tokenUtils.setRefreshToken(response.refreshToken)
      }
    }
    return response
  },

  /**
   * 用户登出
   */
  async logout() {
    try {
      await post(`${AUTH_PREFIX}/logout`)
    } finally {
      tokenUtils.clearTokens()
    }
  },

  /**
   * 获取当前登录用户的客户信息
   */
  async getCurrentCustomer() {
    const response = await get(`${AUTH_PREFIX}/current`)
    return response
  },

  /**
   * 更新用户资料
   */
  async updateProfile(data) {
    const response = await post(`${AUTH_PREFIX}/profile`, {
      fullName: data.fullName,
      phone: data.phone,
      companyName: data.companyName,
    })
    return response
  },

  /**
   * 检查登录状态
   */
  async checkAuth() {
    if (!tokenUtils.isLoggedIn()) {
      return false
    }
    try {
      await get(`${AUTH_PREFIX}/current`)
      return true
    } catch {
      tokenUtils.clearTokens()
      return false
    }
  },

  /**
   * 刷新Token
   */
  async refreshToken() {
    const refreshToken = tokenUtils.getRefreshToken()
    if (!refreshToken) {
      throw new Error('No refresh token')
    }
    const response = await post(`${AUTH_PREFIX}/refresh`, { refreshToken })
    if (response.accessToken) {
      tokenUtils.setToken(response.accessToken)
    }
    return response
  },

  /**
   * 是否已登录
   */
  isLoggedIn() {
    return tokenUtils.isLoggedIn()
  },
}

export default authService
